// extracted by mini-css-extract-plugin
export default {"container":"CampaignAnalytics_container__lQmy8","chart-container":"CampaignAnalytics_chart-container__Ac1Zj","title":"CampaignAnalytics_title__Wuu7w"};